module.exports = "<div style=\"position: relative; height: calc(100vh - 100px);\">\n  <v-layout v-if=\"isLoading\" align-center justify-center style=\"position: absolute; top:0; left:0; right: 0; bottom: 0; z-index: 1000; background: rgba(255, 255, 255, .95)\">\n    <div class=\"primary--text\">\n      <div class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>\n      <div>Patientez SVP ...</div>\n    </div>\n  </v-layout>\n  <v-container pa-3 grid-list-lg>\n    <h1>Contacts</h1>\n  </v-container>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/service-book/contacts/template.html
// module id = 13v/
// module chunks = 0